function getTaskListV2NavigationItem() {
    return {
        label: "app:navigation.task",
        icon: "inbox-bold",
        iconActive: "inbox-filled",
        iconType: "momentum",
        navigateTo: "task",
        align: "top"
    };
}
export function getSupervisorTaskNavigationItem(isTaskListV2Enabled) {
    if (isTaskListV2Enabled) {
        return getTaskListV2NavigationItem();
    }
    return {
        label: "app:navigation.task",
        icon: "view-list",
        iconType: "momentum",
        navigateTo: "task",
        align: "top"
    };
}
export function getDefaultTaskNavigationItem(isTaskListV2Enabled) {
    if (isTaskListV2Enabled) {
        return getTaskListV2NavigationItem();
    }
    return {
        label: "app:navigation.home",
        icon: "home",
        iconActive: "home-active",
        iconType: "momentum",
        navigateTo: "task",
        align: "top"
    };
}
export function getSupervisorDefaultNavigationItems(isTaskListV2Enabled) {
    return [
        getSupervisorTaskNavigationItem(isTaskListV2Enabled),
        {
            label: "app:navigation.help",
            icon: "help-circle",
            iconActive: "help-circle-active",
            iconType: "momentum",
            navigateTo: 
            // eslint-disable-next-line sonarjs/no-clear-text-protocols
            "http://rtp-aspw-crs2/00000018WIA62583B50GYZ/output/output-ciscopdfflbp/cjp_b_30-olh-cisco-webex-contact-center-agent.pdf",
            align: "bottom"
        },
        {
            label: "app:navigation.shareFeedback",
            icon: "survey",
            iconType: "momentum",
            navigateTo: "https://exp.bz/WC-146636",
            align: "bottom"
        }
    ];
}
export function getDefaultNavigationItems(isTaskListV2Enabled) {
    return [
        getDefaultTaskNavigationItem(isTaskListV2Enabled),
        {
            label: "app:navigation.shareFeedback",
            icon: "survey",
            iconType: "momentum",
            navigateTo: "https://exp.bz/WC-146636",
            align: "bottom"
        },
        {
            label: "app:navigation.help",
            icon: "help-circle",
            iconActive: "help-circle-active",
            iconType: "momentum",
            navigateTo: 
            // eslint-disable-next-line sonarjs/no-clear-text-protocols
            "http://rtp-aspw-crs2/00000018WIA62583B50GYZ/output/output-ciscopdfflbp/cjp_b_30-olh-cisco-webex-contact-center-agent.pdf",
            align: "bottom"
        }
    ];
}
